import { takeLatest, put, select } from 'redux-saga/effects'

import { createReducer, makeAction, makeKeys } from './helper'
import { httpPost, httpGet, httpDelete, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import {
  getHrmsMembers,
  getAllMembers
} from './member'
import {
  fetchGoas
} from './goa'
import {
  getPurchasingGroups,
  getCompanies,
} from './options'
import r from 'reactotron-react-js'

const INITIALIZE_TRACKING = 'INITIALIZE_TRACKING'
const CLEAR_TRACKINGDATA = 'CLEAR_TRACKINGDATA'
const FETCH_TRACKINGS = makeKeys('FETCH_TRACKINGS')
const GET_TRACKING_DETAIL = makeKeys('GET_TRACKING_DETAIL')
const SET_TRACKING_DETAIL = 'SET_TRACKING_DETAIL'

export const initializeTracking = makeAction(INITIALIZE_TRACKING)
export const clearTrackingData = makeAction(CLEAR_TRACKINGDATA)
export const fetchTrackings = makeAction(FETCH_TRACKINGS.REQUEST, 'dataSearch')
export const getTrackingDetail = makeAction(GET_TRACKING_DETAIL.REQUEST, 'tkId')
export const setTrackingDetail = makeAction(SET_TRACKING_DETAIL, 'data')

const fetchTrackingsSuccess = makeAction(FETCH_TRACKINGS.SUCCESS, 'data')
const getTrackingDetailSuccess = makeAction(GET_TRACKING_DETAIL.SUCCESS, 'data')


const initial = {
  trackingList: {},
  trackingDetail: { data:{}, loading:false },
}

function* initializePOUpdateRequest() {
  try {
    const state = yield select()
    if (!state.goa.goas.length) {
      yield put(fetchGoas())
    }
    if (!state.member.members.length) {
      yield put(getAllMembers())
      // yield put(getHrmsMembers())
    }
    if(!state.options.companies.data.length){
      yield put(getCompanies())
    }
    if(!state.options.purchasingGroups.data.length){
      yield put(getPurchasingGroups())
    }
  } catch (e) {
    console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
    console.log(e)
  }
}

function* fetchTrackingsRequest( action ) {
  const { dataSearch } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet('trackings',dataSearch)
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchTrackingsSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    yield put(fetchTrackingsSuccess({}))
  }
}

function* getTrackingDetailRequest( action ) {
  const { tkId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(`trackings/${tkId}`)
    // const response = yield httpGet(`mobile/trackings/pr/${tkId}`)
    if (response.status >= 200 && response.status < 300) {
      yield put(getTrackingDetailSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    if(e.data){
      yield put(toastError(e.data.message))
    }else{
      yield put(toastError('Can not connect to server.'))
    }
    yield put(appLoaded())
  }
}

export function* watchTrackingSaga() {
  yield takeLatest(INITIALIZE_TRACKING, initializePOUpdateRequest)
  yield takeLatest(FETCH_TRACKINGS.REQUEST, fetchTrackingsRequest)
  yield takeLatest(GET_TRACKING_DETAIL.REQUEST, getTrackingDetailRequest)
}

export default createReducer(initial, state => ({
  [CLEAR_TRACKINGDATA]: () => ({
    ...state,
    trackingDetail:{ data:{}, loading:false }
  }),
  [FETCH_TRACKINGS.REQUEST]: () => ({
    ...state
  }),
  [FETCH_TRACKINGS.SUCCESS]: (data) => ({
    ...state,
    trackingList: data.data
  }),
  [GET_TRACKING_DETAIL.REQUEST]: () => ({
    ...state,
    trackingDetail:{ data:{}, loading:true}
  }),
  [GET_TRACKING_DETAIL.SUCCESS]: (data) => ({
    ...state,
    trackingDetail:{ data:data.data, loading:false}
  }),
  [SET_TRACKING_DETAIL]: (data) => ({
    ...state,
    trackingDetail:{ data:data.data, loading:false}
  }),
}))